module.exports = __webpack_public_path__ + "static/media/politics.013c487d.pdf";